// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__NVKMk","icon":"style_icon__m_OCV","title":"style_title__1CRT_","logo":"style_logo__3NJIC","logoContainer":"style_logoContainer__1nHoA"};